module.exports = __webpack_public_path__ + "img/LA-cleantech-incubator@2x.98b00a80.webp";